import { useEffect, useState } from 'react';

// Under 768px the portal's Work surface behaves differently, not merely looks
// different: the header's sliders button opens the Sort & filter sheet instead
// of the inline chip bar, and a tap on a task row expands its quick-action bar
// instead of opening the detail. Those are BEHAVIOUR forks, so they need the
// breakpoint in JS — CSS alone can only hide things.
//
// Tracks the same 768px line the mobile action bar and desktop New-task button
// already use in WorkTasks.css. Extracted from WorkTasksModule (where it lived
// first) once TaskRow needed it too; the behaviour is unchanged.
// NOT-SUPPORTED FALLS BACK TO DESKTOP, AND THAT DIRECTION IS DELIBERATE.
// `window.matchMedia` is absent in jsdom and under SSR, and this hook is now
// called by every task row rather than once by the module — so an unguarded
// call takes down the entire list, which is exactly what it did the first time
// (17 pre-existing row tests died on `matchMedia is not a function`). Desktop is
// the safe default because it is the PRE-EXISTING behaviour: a click opens the
// detail. Defaulting the other way would hand an unknown environment the newer,
// forked interaction.
const supported = () =>
	typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export function useIsMobile(query = '(max-width: 767px)') {
	const [isMobile, setIsMobile] = useState(
		() => (supported() ? window.matchMedia(query).matches : false)
	);
	useEffect(() => {
		if (!supported()) return undefined;
		const mql = window.matchMedia(query);
		const onChange = (e) => setIsMobile(e.matches);
		mql.addEventListener('change', onChange);
		setIsMobile(mql.matches);
		return () => mql.removeEventListener('change', onChange);
	}, [query]);
	return isMobile;
}

export default useIsMobile;
